import React from 'react'

import clsx from 'clsx'

import classes from './HighlightedText.module.scss'

/** @type {import("./types").default} */
const HighlightedText = ({ highlight, children }) => {
  if (!highlight) {
    return <span className="HighlightedText">{children}</span>
  }
  const regex = new RegExp(`(${highlight.trim()})`, 'gi')
  const parts = children.split(regex)
  return (
    <span className="HighlightedText">
      {parts.map((part, i) => {
        const isHighlighted = part.trim().toLowerCase() === highlight.trim().toLowerCase()
        return (
          // eslint-disable-next-line react/no-array-index-key
          <span key={`${children}-${part}-${i}`} className={clsx({ [classes.highlighted]: isHighlighted })}>
            {part}
          </span>
        )
      })}
    </span>
  )
}

export default HighlightedText
